import http from './api'

const route = 'send/'

export default {
    send: (email, obj, type, tokencontrato) => {
        return http.post(route + 'send', {
            email: email,
            obj: obj,
            type: type,
            tokencontrato: tokencontrato,
        })
    },
}
